import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import withIframeHeightUpdate, { isInIframe } from 'hoc/withIframeHeightUpdate';

import './assets/style/index.css';
import Wizard from './views/Home';

const theme = getMuiTheme({
  raisedButton: {
    primaryColor: '#d80a08',
  },
  fontFamily: 'proxima-nova',
  palette: {
    primary1Color: '#000000',
    primary2Color: '#d77e81',
    primary3Color: '#bdbdbd',
    accent1Color: '#d77e81',
    accent2Color: '#f5f5f5',
    accent3Color: '#9e9e9e',
    textColor: '#7b7b7b',
    secondaryTextColor: 'rgba(0, 0, 0, 0.54)',
    alternateTextColor: '#ffffff',
    canvasColor: '#ffffff',
    borderColor: '#4d4d4d',
    disabledColor: 'rgba(0, 0, 0, 0.4)',
    pickerHeaderColor: '#2C2C2C',
    clockCircleColor: 'rgba(0, 0, 0, 0.07)',
    shadowColor: 'rgba(0, 0, 0, 1)',
  },
});

const App = () => (
  <MuiThemeProvider muiTheme={theme}>
    <Wizard />
  </MuiThemeProvider>
);

// If app is loaded in iframe, post app height to parent on updates and dispatches
export default isInIframe() ? withIframeHeightUpdate(App) : App;



// WEBPACK FOOTER //
// ./src/App.js